/**
 * Products Page - MPAD Phase 1 Implementation
 * Products Catalog Foundation with Semantic Capacity System
 */

import React from 'react';
import { Container, Box, Typography, Paper } from '@mui/material';
import { Inventory } from '@mui/icons-material';
import ProductForm from '../components/ProductCatalog/ProductForm';
import ProductSelector from '../components/ProductCatalog/ProductSelector';
import { useCreateProduct, ProductCreate } from '../hooks/useProducts';

const ProductsPage: React.FC = () => {
  // TODO: Replace with Toolpad navigation
  const currentProject = null;

  const createProductMutation = useCreateProduct();

  const handleSaveProduct = async (product: ProductCreate) => {
    if (!currentProject?.id) {
      throw new Error('No project selected');
    }

    try {
      await createProductMutation.mutateAsync({
        product,
        projectId: currentProject.id
      });
      console.log('Product created successfully in database');
    } catch (error) {
      console.error('Error creating product:', error);
      throw error;
    }
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Typography 
          variant="h4" 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1,
            fontWeight: 'bold',
            color: 'primary.main'
          }}
        >
          <Inventory />
          Products Catalog
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
          MPAD Phase 1: Manage your product catalog with semantic capacity calculations.
          Replace meaningless arrays with product-based capacity requirements.
        </Typography>
      </Box>

      <Paper sx={{ p: 3 }}>
        {currentProject ? (
          <ProductForm 
            onSave={handleSaveProduct}
            onCancel={() => {
              console.log('Product creation cancelled');
            }}
            mode="create"
            loading={createProductMutation.isPending}
          />
        ) : (
          <Typography variant="body1" color="text.secondary">
            Please select a project to manage products.
          </Typography>
        )}
      </Paper>
    </Container>
  );
};

export { ProductsPage };